import { isOverflowX, isOverflowY } from "../../utils/overFlowCheck";
import React, { useEffect, useRef, useState } from "react";
import styles from "./OverflowCheckDiv.module.scss";
import { placement, Tooltip } from "../../Tooltip";
import classnames from "classnames";

const checkDescendantsOverflow = (element: HTMLElement): boolean => {
  if (isOverflowX(element as HTMLDivElement) || isOverflowY(element as HTMLDivElement)) {
    return true;
  }
  const children = element.children;
  for (let i = 0; i < children.length; i++) {
    if (checkDescendantsOverflow(children[i] as HTMLElement)) {
      return true;
    }
  }
  return false;
};

const getAutoPlacement = (element: HTMLDivElement): placement => {
  const { left, right, width } = element.getBoundingClientRect();
  const spaceOnLeft = left + width / 2;
  const spaceOnRight = window.innerWidth - right + width / 2;

  if (spaceOnRight < spaceOnLeft) return "top-left";
  if (spaceOnLeft < spaceOnRight) return "top-right";
  return "top";
};

export const OverflowCheckDiv: React.FC<
  React.HTMLProps<HTMLDivElement> & { tooltipText: string | React.ReactNode; tooltipDirection?: placement; deep?: boolean; tooltipClassName?: string }
> = ({ tooltipText, children, tooltipDirection, deep, tooltipClassName, ...props }) => {
  const divRef = useRef<HTMLDivElement>(null);
  const [isOverflow, setIsOverFlow] = useState(false);

  useEffect(() => {
    if (!divRef.current) return;
    if (isOverflowX(divRef.current) || isOverflowY(divRef.current)) {
      setIsOverFlow(true);
    } else if (deep && checkDescendantsOverflow(divRef.current)) {
      setIsOverFlow(true);
    }
  }, [deep]);

  const resolvedPlacement = tooltipDirection ?? (divRef.current ? getAutoPlacement(divRef.current) : "top");

  return (
    <div {...props} ref={divRef}>
      <Tooltip value={tooltipText} disabled={!isOverflow} className={classnames(styles.tooltip, tooltipClassName)} placement={resolvedPlacement}>
        <span>{children}</span>
      </Tooltip>
    </div>
  );
};
